<template>
  <div id="surveyDetailPage"
       class="container-fluid has-action-bar has-footer">
    <div v-if="showAlert" class="mx-2 mt-5 knowledge-base-body">
      <div class="col-12">
        <v-alert
            border="bottom"
            class="text-center"
            dark
            type="warning">
          مهلت شما برای پاسخ به سوالات به اتمام رسیده در صورت ثبت نکردن پاسخ ها،میتوانید تا پایان اتمام ساعت پایانی
          نظرسنجی پاسخنامه خود را ثبت کنید.
        </v-alert>
      </div>
    </div>
    <div v-if="examDetail !== null">
      <ActionBar :title=" 'نظر سنجی ' + examDetail.Name "></ActionBar>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-5">
            <div><span class="font-weight-bold"><i class="fas fa-calendar-alt primary-text pl-2"></i> تاریخ برگزاری نظر سنجی:</span>
              {{ $convertDate(examDetail.ExamStartDate) }}
            </div>
          </div>
          <div class="col-12 col-md-5">
            <div><span class="font-weight-bold"><i class="fas fa-alarm-clock primary-text pl-2"></i> ساعت برگزاری نظر سنجی:</span>
              از {{ (examDetail.TimeEnd).slice(0, 5) }} تا {{ (examDetail.TimeStart).slice(0, 5) }}
            </div>
          </div>
          <div v-if="currentExam" class="col-12 col-md-5">
            <div><span class="font-weight-bold"><i class="fas fa-user-clock primary-text pl-2"></i> زمان پاسخ به نظر سنجی:</span>
              {{ examDetail.Minute }} دقیقه
            </div>
          </div>
          <div v-if="currentExam" class="col-12 col-md-5">
            <div><span class="font-weight-bold"> <i class="fas fa-stopwatch primary-text pl-2"></i>  پایان نظر سنجی برای شما:  </span>
              {{ userExamEndTime }}
            </div>
          </div>
          <div class="col-12 ">
            <div class="font-weight-bold">درباره نظر سنجی:</div>
            {{ examDetail.Description }}
          </div>
          <div v-if="isPdfLoaded" class="col-12 p-0">
            <vue-pdf-app :config="config" :pdf="pdfUrl" style="height: 100vh"></vue-pdf-app>
          </div>

          <!--        <iframe :src="examDetail.FileUrl" width="100%" height="500px">-->

          <!--        </iframe>-->
          <!--        <pdf  src="https://admin.masirebartarapp.com/img/ExamModel/e76c7e98b982409bbf57eee206610246.pdf"></pdf>-->

        </div>
      </div>
      <v-fab-transition>
        <v-btn
            id="memberShipFabBtn"
            color="forth"
            dark
            fab
            fixed
            left
            x-large
            @click="drawer= true">
          <div class="text-center">
            پاسخنامه
          </div>
        </v-btn>
      </v-fab-transition>
      <v-navigation-drawer
          v-model="drawer"
          color="third"
          fixed
          right
          style="height:100vh !important;"
          temporary>
        <div v-if="isLoaded" class="container">
          <div class="row">
            <div class="third-background col-12 white--text text-center">
              پاسخنامه
            </div>
            <div v-for="index in examDetail.NumberQuestion" :key="index" class="col-12 fourth-border-bottom">
              <div class="font-weight-bold text-center"><i class="fal fa-pencil-alt primary-text font16px"></i> پاسخ
                سوال
                {{ index }}
              </div>
              <div v-if="examDetail.TypeAnswerVote === 2" class="options-field ">
                <v-radio-group
                    v-model="fourChoiceAnswer[index]"
                    :readonly="canAnswer"
                    column
                    dense
                    hide-details
                    @change="saveAnswers">
                  <v-radio
                      label="گزینه 1"
                      value="1"></v-radio>
                  <v-radio
                      label="گزینه 2"
                      value="2"></v-radio>
                  <v-radio
                      label="گزینه 3"
                      value="3"></v-radio>
                  <v-radio
                      label="گزینه 4"
                      value="4"></v-radio>
                </v-radio-group>
              </div>
              <div v-else class="options-field">
                <v-radio-group
                    v-model="fourChoiceAnswer[index]"
                    :readonly="canAnswer"
                    column
                    details
                    @change="saveAnswers">
                  <v-radio
                      label="گزینه 1"
                      value="1"></v-radio>
                  <v-radio
                      label="گزینه 2"
                      value="2"></v-radio>
                </v-radio-group>
              </div>

            </div>
            <div class="col-12 text-center">
              <div v-if="currentExam" class="">
                <v-btn color="primary" rounded @click="checkCanRegister">ثبت پاسخنامه
                </v-btn>
              </div>
            </div>
          </div>

        </div>
      </v-navigation-drawer>

    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showConfirmSetAnswer"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">آیا از اتمام نظر سنجی و ثبت پاسخ مطمئنید؟</div>
          <div class="mb-0 black--text font12px">بعد از ثبت پاسخ امکان تغییر آن وجود ندارد.</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="forth" rounded @click="showConfirmSetAnswer = !showConfirmSetAnswer">
            <span class="white--text">بستن</span>
          </v-btn>
          <v-btn class="px-8" color="primary" rounded @click="setAnswer">
            ثبت پاسخ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
let _this = null
let checkInterval = null
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "SurveyDetail",
  metaInfo: {
    title: 'مسیربرتر-نظرسنجی'
  },
  components: {FooterMenu, ActionBar, VuePdfApp},
  data: () => ({
    fourChoiceAnswer: {},
    examDetail: null,
    isLoaded: false,
    pdfUrl: null,
    drawer: false,
    examDetailID: null,
    showResultDialog: false,
    dialogResult: null,
    showLoaderDialog: false,
    showConfirmSetAnswer: false,
    isPdfLoaded: false,
    canAnswer: null,
    voteID: null,
    typeFeedbackExam: null,
    correctAnswer: null,
    showCorrectAnswers: false,
    correctAnswerPercentage: 0,
    showPercentage: false,
    disabledRegisterBtn: false,
    userExamEndTime: null,
    currentExam: true,
    showAlert: false,
    config: {
      secondaryToolbar: false,
      toolbar: {
        toolbarViewerLeft: {findbar: false},
        toolbarViewerRight: false,
        toolbarViewerMiddle: {
          scaleSelectContainer: false
        }
      }

    },

  }),
  mounted () {
    _this = this;
    this.showLoaderDialog = true
    this.voteID = this.$route.query.VoteID
    this.getExamDetail();
    this.setPageState();

    if (this.currentExam) {
      checkInterval = setInterval(function () {
        let currentDate = new Date();
        let currentTime = currentDate.getHours() + ':' + currentDate.getMinutes()
        if (_this.userExamEndTime < currentTime) {
          _this.canAnswer = true
          if (_this.canAnswer && _this.currentExam && _this.showPercentage) {
            _this.showAlert = false
          } else {
            _this.showAlert = true
          }
        }
      }, 30000)
    }

  },
  destroyed () {
    clearInterval(checkInterval)
  },
  methods: {
    checkCanRegister () {
      let current = new Date()
      let examEnd = this.examDetail.ExamEndDate.slice(0, 11) + this.examDetail.TimeEnd
      if (current <= new Date(examEnd)) {
        this.showConfirmSetAnswer = true
      } else {
        this.dialogResult = 'زمان نظر سنجی به پایان رسیده است'
        this.showResultDialog = true
      }
    },
    setPageState () {
      if (this.$route.query.CanAnswer === 'true') {
        this.canAnswer = false
      } else if (this.$route.query.CanAnswer === 'false') {
        this.canAnswer = true
      }

      if (this.$route.query.currentVote === 'true') {
        this.currentExam = true
      } else if (this.$route.query.currentVote === 'false') {
        this.currentExam = false
      }

      this.userExamEndTime = (this.$getVoteData())[this.voteID]
      let currentDate2 = new Date();
      let currentTime2 = ((new Date(currentDate2.getTime())).toLocaleTimeString('en-GB')).slice(0, 5)
      if (_this.userExamEndTime < currentTime2) {
        _this.canAnswer = true
        if (_this.canAnswer && _this.currentExam) {
          _this.showAlert = false
        } else {
          _this.showAlert = false
        }
      }
    },
    setSaveAnswers () {
      let answers = this.$getVoteAnswers()

      if (answers[this.voteID] !== undefined) {
        this.fourChoiceAnswer = answers[this.voteID]
      } else {
        let numQuestion = this.examDetail.NumberQuestion
        for (let i = 1; i <= numQuestion; i++) {
          this.fourChoiceAnswer[i] = '0'
        }
      }
    },
    saveAnswers () {
      this.$setVoteAnswers(this.voteID, this.fourChoiceAnswer)
    },
    getExamDetail () {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VoteManagement/SpcialVote?VoteID=" + this.$route.query.VoteID, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            _this.examDetail = json
            _this.setSaveAnswers()
            _this.typeFeedbackExam = json.TypeFeedbackExam
            _this.showLoaderDialog = false
            _this.pdfUrl = _this.$replaceHttps(json.FileUrl)
            _this.isLoaded = true
            _this.isPdfLoaded = true
          })
          .catch(error => console.log('error', error));
    },
    setAnswer () {
      this.showConfirmSetAnswer = false;
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();

      urlencoded.append("VoteID", this.voteID);

      let numQuestion = _this.examDetail.NumberQuestion
      let answers = this.fourChoiceAnswer
      let j = 0
      for (let i = 1; i <= numQuestion; i++) {
        urlencoded.append("YourAnswer[" + j + "].Key", i);
        if (answers[i] === undefined) {
          urlencoded.append("YourAnswer[" + j + "].Value", 0);
        } else {
          urlencoded.append("YourAnswer[" + j + "].Value", answers[i]);
        }
        j++
      }

      /*for (const [key, value] of urlencoded.entries()) {
        console.log(key, value)
      }*/


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VoteManagement/SetAnswer", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false

            _this.dialogResult = result;
            _this.showResultDialog = true
            _this.canAnswer = true
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>